import { Tag } from '@jouzen/ecom-components/v3/Tag';
import { Typography } from '@jouzen/ecom-components/v3/Typography';
import { useTranslations } from 'next-intl';

import RichText from '@/app/components/RichText';
import { useHsaFsa } from '@/app/hooks/useHsaFsa';
import useMembershipPricing from '@/app/hooks/useMembershipPricing';

const TitleCardHealthJourney = () => {
  const t = useTranslations();
  const membershipPricing = useMembershipPricing({ showCurrency: false });
  const membershipPrice = membershipPricing['monthlyCost']!;
  const isHSAFSA = useHsaFsa().isAvailable;
  return (
    <div className="flex flex-col items-center px-6 pt-10 pb-6 md:pt-20 md:pb-10">
      <Tag>{t('membership_get_started')}</Tag>
      <Typography
        className="pt-2 pb-6 text-center text-heading-xl md:pt-4 md:text-heading-6xl"
        font="serif"
      >
        {t('membership_title_start_journey')}
      </Typography>
      {isHSAFSA ? (
        <Typography className="max-w-240 text-center text-body-lg md:text-xl" data-cy='usa_hsa_text'>
          <RichText
            messageKey="membership_hsa_fsa_usa_text"
            tValues={{ membershipPrice }}
          />
        </Typography>
      ) : (
        <Typography className="max-w-240 text-center text-body-lg md:text-xl" data-cy='non_usa_text'>
          <RichText
            messageKey="membership_non_us_text"
            tValues={{ membershipPrice }}
          />
        </Typography>
      )}
    </div>
  );
};
export default TitleCardHealthJourney;
